import { DocumentationItem } from './documentation';

export enum SnowflakeParentType {
  TABLE = 'TABLE',
  VIEW = 'VIEW',
  TASK = 'TASK',
  STREAM = 'STREAM',
  PROCEDURE = 'PROCEDURE',
  FUNCTION = 'FUNCTION',
  STAGE = 'STAGE',
  SEQUENCE = 'SEQUENCE',
  SCHEMA = 'SCHEMA',
}

export interface SnowflakeItemBase extends DocumentationItem {
  schema?: string;
  catalog?: string;
  owner?: string;
  comment?: string;
  body?: string;
}

export interface SnowflakeTableItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.TABLE;
  tableType?: string;
  retentionTime?: string;
  clusteringKey?: string;
  isTransient?: string;
  changeTracking?: string;
}

export interface SnowflakeViewItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.VIEW;
  isSecure?: string;
  isMaterialized?: string;
  queryDefinition?: string;
}

export interface SnowflakeTaskItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.TASK;
  warehouse?: string;
  schedule?: string;
  state?: string;
  condition?: string;
}

export interface SnowflakeStreamItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.STREAM;
  sourceObject?: string;
  streamType?: string;
  stale?: string;
}

export interface SnowflakeProcedureItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.PROCEDURE;
  language?: string;
  arguments?: string;
  returnType?: string;
  executeAs?: string;
}

export interface SnowflakeFunctionItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.FUNCTION;
  language?: string;
  arguments?: string;
  returnType?: string;
  isSecure?: string;
}

export interface SnowflakeStageItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.STAGE;
  stageType?: string;
  url?: string;
  fileFormat?: string;
}

export interface SnowflakeSequenceItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.SEQUENCE;
  increment?: string;
  startValue?: string;
  minValue?: string;
  maxValue?: string;
  cycle?: string;
}

export interface SnowflakeSchemaItem extends SnowflakeItemBase {
  parentType: SnowflakeParentType.SCHEMA;
  managedAccess?: string;
}

export type SnowflakeConfigurationItem =
  | SnowflakeTableItem
  | SnowflakeViewItem
  | SnowflakeTaskItem
  | SnowflakeStreamItem
  | SnowflakeProcedureItem
  | SnowflakeFunctionItem
  | SnowflakeStageItem
  | SnowflakeSequenceItem
  | SnowflakeSchemaItem;

export interface SnowflakeDocumentationListElementsResponse {
  elements: SnowflakeConfigurationItem[];
  count: number;
}

export type SnowflakeDocumentationSearchResponse = Record<string, SnowflakeConfigurationItem[]>;

export enum RelationshipDirection {
  DEPENDENCIES = 'dependencies',
  DEPENDENTS = 'dependents',
  BOTH = 'both',
}

export interface SnowflakeDocumentationRelationshipsResponse {
  dependencies: Record<string, SnowflakeConfigurationItem[]>;
  dependents: Record<string, SnowflakeConfigurationItem[]>;
}
